import React, { useCallback, useEffect, useState } from "react";
import Container from "../components/Container";
import MainCard from "../components/MainCard";
import PageContainer from "../components/PageContainer";
import DateRangePicker from "../sections/statistics/DateRangePicker";
import ComplaintRateChart from "../sections/statistics/ComplaintRateChart";
import ContactChannelsChart from "../sections/statistics/ContactChannelsChart";
import dayjs from "dayjs";
import { getSummaryCase, getSummaryChannel } from "../api/statistics";
import StatusCard from "../sections/statistics/StatusCard";

const Statistics = () => {
  const [summaryCase, setSummaryCase] = useState({
    cntAll: 0,
    cntConsider: 0,
    cntFinal: 0,
    cntTracking: 0,
  });

  const [summaryChannel, setSummaryChannel] = useState([]);
  const [channelsValue, setChannelsValue] = useState({
    telephone: 0,
    email: 0,
    line: 0,
    facebook: 0,
    application: 0,
  });

  const [dateRange, setDateRange] = useState({
    startDate: dayjs().subtract(3, "month").toDate(),
    endDate: dayjs().toDate(),
  });

  console.log("dateRange", dateRange);

  const getDataCase = useCallback(async () => {
    try {
      const payload = {
        keyword: "",
        dtstart: dayjs(dateRange.startDate)
          .startOf("month")
          .format("YYYY-MM-DD"),
        dtend: dayjs(dateRange.endDate).endOf("month").format("YYYY-MM-DD"),
      };

      const data = await getSummaryCase(payload);

      if (data.results.length) {
        setSummaryCase(data.results[0]);
      }
    } catch (error) {
      console.log("error", error);
    }
  }, [dateRange, setSummaryCase]);

  useEffect(() => {
    getDataCase();
  }, [getDataCase]);

  const getDataChannel = useCallback(async () => {
    try {
      setSummaryChannel([]);
      // const payload = {
      //   keyword: "",
      //   dtstart: dayjs(dateRange.startDate)
      //     .startOf("month")
      //     .format("YYYY-MM-DD"),
      //   dtend: dayjs(dateRange.endDate).endOf("month").format("YYYY-MM-DD"),
      // };

      const payloads = [];
      let currentStartDate = dayjs(dateRange.startDate).startOf("month");

      while (currentStartDate.isBefore(dayjs(dateRange.endDate))) {
        const currentEndDate = currentStartDate.endOf("month");
        payloads.push({
          keyword: "",
          dtstart: currentStartDate.format("YYYY-MM-DD"),
          dtend: currentEndDate.format("YYYY-MM-DD"),
        });
        currentStartDate = currentStartDate.add(1, "month").startOf("month");
      }

      console.log("payloads", payloads);

      for (const payload of payloads) {
        const data = await getSummaryChannel(payload);

        const mapData = {
          month: dayjs(payload.dtstart).format("MMM YYYY"),
          data: data.results,
        };

        setSummaryChannel((prev) => [...prev, mapData]);
      }

      // if (data.results.length) {
      //   setSummaryCase(data.results[0]);
      // }
    } catch (error) {
      console.log("error", error);
    }
  }, [dateRange]);

  useEffect(() => {
    getDataChannel();
  }, [getDataChannel]);

  useEffect(() => {
    const mapData = summaryChannel.flatMap((ch) => ch.data);
    const lineChannel = mapData.filter((ch) => ch.id.toLowerCase() === "line");
    const emailChannel = mapData.filter(
      (ch) => ch.id.toLowerCase() === "email"
    );
    const telephoneChannel = mapData.filter(
      (ch) => ch.id.toLowerCase() === "phone"
    );
    const facebookChannel = mapData.filter(
      (ch) => ch.id.toLowerCase() === "facebook"
    );
    const applicationChannel = mapData.filter(
      (ch) => ch.id.toLowerCase() === "application"
    );

    setChannelsValue({
      telephone: telephoneChannel.reduce((acc, cur) => acc + cur.count, 0),
      email: emailChannel.reduce((acc, cur) => acc + cur.count, 0),
      line: lineChannel.reduce((acc, cur) => acc + cur.count, 0),
      facebook: facebookChannel.reduce((acc, cur) => acc + cur.count, 0),
      application: applicationChannel.reduce((acc, cur) => acc + cur.count, 0),
    });

    // console.log("channels", channels);
  }, [summaryChannel]);

  console.log("summaryCase", summaryCase);
  console.log("summaryChannel", summaryChannel);

  return (
    <PageContainer title="สถิติการให้บริการประชาชน">
      <Container isAlignTop>
        <MainCard bodyClassName="min-h-[400px]">
          <DateRangePicker dateRange={dateRange} setDateRange={setDateRange} />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            <ComplaintRateChart
              labels={summaryChannel.map((channel) => channel.month)}
              datas={summaryChannel.map((channel) => {
                return channel.data.reduce((acc, cur) => acc + cur.count, 0);
              })}
            />
            <ContactChannelsChart
              line={channelsValue.line}
              fb={channelsValue.facebook}
              app={channelsValue.application}
              email={channelsValue.email}
              telephone={channelsValue.telephone}
            />
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-1 mt-4">
              ข้อมูลการรับแจ้งเหตุทาง ระบบ Ticket Management ของสำนักปฏิบัติการ
            </h2>
            <div className="flex gap-4 justify-center items-center mt-1">
              <StatusCard
                title="ทั้งหมด"
                count={summaryCase.cntAll}
                color="bg-blue-500"
              />
              <StatusCard
                title="รับแจ้งเหตุ"
                count={summaryCase.cntConsider}
                color="bg-red-500"
              />
              <StatusCard
                title="กำลังดำเนินการ"
                count={summaryCase.cntTracking}
                color="bg-yellow-400"
              />
              <StatusCard
                title="สิ้นสุด"
                count={summaryCase.cntFinal}
                color="bg-green-500"
              />
            </div>
          </div>
        </MainCard>
      </Container>
    </PageContainer>
  );
};

export default Statistics;
